<template>
    <md-content class=" md-layout-item md-size-100 md-small-size-100">
        <div class="md-flex-center-center md-form-input md-relative">
            <div class="md-flex-center-center md-relative" style="margin-top:20px">
                <md-content style="text-align:center; white-space: nowrap;">{{ $t('views.main.links.add-order-summary') }} </md-content>
            </div>
            <div class="md-flex-center-center md-relative">
                <md-content style="font-size: 18px; text-align: center; margin-bottom: -70px"> {{ $t('views.order.summary.table.order-information') }} </md-content>
            </div>
            <md-card class="md-form-card md-mt-70">
<md-table v-model="orders" v-if="orders.some(order => order.orderProducts)">
                    <md-table-row slot="md-table-row" slot-scope="{ item, index }">
                        <md-table-cell md-numeric :md-label="$t('views.order.summary.table.no')">
                            {{ getNo(index) }}
                        </md-table-cell>
                        <md-table-cell :md-label="$t('views.order.summary.table.type')">{{ item.orderType.shortName.toUpperCase() }}</md-table-cell>
                        <md-table-cell :md-label="$t('views.order.summary.table.products')">
                            {{ orderProductsList(item.orderProducts) }}
                        </md-table-cell>
                        <md-table-cell :md-label="$t('views.order.summary.table.packageType')">{{ getPackageType(item) }}</md-table-cell>
                        <md-table-cell :md-label="$t('views.order.summary.table.cost')">{{ formatCpp(cpp[item.id]) }}</md-table-cell>
                        <md-table-cell :md-label="$t('views.order.summary.table.budget')">
                            {{ item.priceMethod == 'budget' && item.budget != 0.1 && item.budget != 0.2 && item.budget != 0 ? formatLocaleNumber(item.budget) : '' }}
                        </md-table-cell>
                        <md-table-cell :md-label="$t('views.order.summary.table.grp')">
                            {{ item.priceMethod == 'grp' && formatLocaleNumber(item.grp) || '' }}
                        </md-table-cell>
                    </md-table-row>
                    <md-table-empty-state class="md-layout-item md-size-100" :md-label="$t('dialog.noData')" />
                </md-table>

                <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30">
                    <md-button class="md-accent md-raised" :disabled="!isWizardValid" @click.once="send">
                        {{ !sending ? $t('views.order.summary.send') : '' }}
                        <md-progress-spinner v-if="sending" :md-diameter="20" :md-stroke="3"
                                md-mode="indeterminate" />
                    </md-button>
                </div>
            </md-card>
        </div>
    </md-content>
</template>

<script>
import sortSupport from '@/mixins/sortSupport';
import {campaignsEndpoint, ordersEndpoint} from '@/services/adsign-backend/endpoints';
import orderCommons from '@/mixins/orderCommons';

export default {
    name: 'CampaignSummary',
    mixins: [sortSupport, orderCommons],
    props: {
        common: {
            type: Object,
            required: true
        },
        orders: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        isWizardValid() {
            return this.orders.every(order => order.isValid && order.status == 'CREATE');
        }
    },
    data: function() { return {
        campaignId: this.common.id,
        cpp: {},
        sending: false
    }},
    methods: {
        getPackageType(orderItem) {
            if (orderItem.packageTypeData?.canAddManuallyStations) {
                return orderItem.orderStations.map(item => item.stationName).join(', ');
            }

            return orderItem.packageTypeData?.packageType?.name || '';
        },

        formatCpp(cpp) {
            if (cpp) {
                return `PT: ${cpp.cppPrimeTime} OFF: ${cpp.cppOffTime}`
            } else {
                return '';
            }
        },

        orderProductsList(orderProducts) {
            return orderProducts.map(op => op.productName).join(', ');
        },

        send() {
            this.sending = true;
            campaignsEndpoint.placeCampaign(this.campaignId, true).then(() => {
                this.$router.push('/orders');
            }).finally(() => this.sending = false)
        }
    },
    mounted() {
        this.$watch(() => this.$route, route => {
            if (route.path.endsWith('summary')) {
                this.orders.forEach(order => {
                    ordersEndpoint.getOrderCpp(order.id).then(result => this.$set(this.cpp, order.id, result.data))
                })
            }
        }, {
          immediate: true
        })
    }
}
</script>

<style scoped lang="scss">
</style>
